import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transferList: [],
  loading: false,
  error: null,
};

const transferSlice = createSlice({
  name: "GetAllTransfer",
  initialState,
  reducers: {
    fetchTransferStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchTransferSuccess: (state, action) => {
      state.loading = false;
      state.transferList = action.payload;
    },

    fetchTransferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchTransferStart,
  fetchTransferSuccess,
  fetchTransferFailure,
} = transferSlice.actions;

export default transferSlice.reducer;
